import {Route, Routes, Outlet} from 'react-router-dom'
import ListWrapper from './list/ListWrapper'
import ViewWrapper from './view/ViewWrapper'
import BrandWrapper from '../brands/list/ListWrapper'

const ProductsPage = () => (
  <Routes>
    <Route element={<Outlet />}>
      <Route path='/catalog' element={<ListWrapper />} />
      <Route path='/:id/*' element={<ViewWrapper />} />
      <Route path='/brand' element={<BrandWrapper />} />
    </Route>
  </Routes>
)

export default ProductsPage
